<template>
  <div>
    <div class="crumbs">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item>
          <i class="el-icon-lx-calendar"></i> 生产管理
        </el-breadcrumb-item>
        <el-breadcrumb-item>重码查询</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="container">
      <div class="handle-box">
        <el-form ref="searchform" :model="searchform" label-width="80px" @keyup.enter.native="search()">
          <el-row>
            <el-col :span="6">
              <el-form-item label="盒码/箱码" prop="qrcode">
                <el-input v-model="searchform.qrcode" style="width: 100%" clearable placeholder="请输入盒码/箱码" />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="创建时间" prop="datelist">
                <el-date-picker style="width: 100%" v-model="searchform.datelist" type="daterange"
                  value-format="yyyy-MM-dd" range-separator="-" start-placeholder="开始日期"
                  end-placeholder="结束日期"></el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="8" style="margin-left: 10px">
              <el-button @click="resetForm('searchform')">重置</el-button>
              <el-button type="primary" icon="el-icon-search" @click="search"
                v-permission="['repeatedquery_select']">搜索</el-button>
              <!-- <el-button
              v-permission="['unrelevance1_export']"
                :loading="downloadLoading"
                type="primary"
                icon="document"
                @click="handleDownload"
              >导出Excel</el-button> -->
            </el-col>
          </el-row>
        </el-form>
      </div>
      <br />
      <el-row type="flex" class="row-bg">
        <el-col :span="24" class="border">
          <h4>重码查询</h4>
          <el-divider></el-divider>
          <el-table border v-loading="listLoading" element-loading-text="拼命加载中" :data="tableData" style="width: 100%"
            id="parent">
            <el-table-column prop="qrcode" label="重复码" min-width="150" show-overflow-tooltip></el-table-column>
            <el-table-column prop="batchno_new" label="重码批次" min-width="100" show-overflow-tooltip></el-table-column>
            <el-table-column prop="batchno_old" label="旧批次" min-width="100" show-overflow-tooltip></el-table-column>
            <el-table-column prop="orderno_new" label="重码工单" min-width="100" show-overflow-tooltip></el-table-column>
            <el-table-column prop="orderno_old" label="旧工单" min-width="100" show-overflow-tooltip></el-table-column>
            <el-table-column prop="package_level_old" label="包装级别" min-width="100"
              show-overflow-tooltip></el-table-column>
            <el-table-column prop="product_code_new" label="重码产品编码" min-width="90"
              show-overflow-tooltip></el-table-column>
            <el-table-column prop="product_code_old" label="旧产品编码" min-width="90"
              show-overflow-tooltip></el-table-column>
            <el-table-column prop="create_date" label="创建时间" min-width="130" show-overflow-tooltip></el-table-column>
            <el-table-column prop="msg" label="重码原因" min-width="130" show-overflow-tooltip></el-table-column>
          </el-table>
          <br />
          <el-pagination background @current-change="currentchange" @size-change="pagesize"
            :current-page.sync="currentPage" :page-sizes="[20, 30, 40, 50]"
            layout="total,prev, pager, next,jumper,sizes" :total="total_count"></el-pagination>
        </el-col>
      </el-row>
    </div>
  </div>
</template>
<script>
import { recodelist } from "@/api/plant";
export default {
  mounted() { },
  data() {
    return {
      //基础数据
      listLoading: false,
      depart_uuid: [],
      tableData: [],
      //分页数据
      pagesizes: "",
      total_count: 1,
      currentPage: 1,
      //导出表格变量
      tableDataDownload: [],
      downloadLoading: false,
      filename: "",
      autoWidth: true,
      bookType: "xlsx",
      //搜索表单数据
      searchform: {
        orderno: "",
        batchno: "",
        qrcode: "",
        boxCode: "",
        datelist: [],
        create_start_time: "",
        create_end_time: "",
        pageIndex: 1,
        pageSize: 20,
      },
    };
  },
  methods: {
    //请求表格数据
    Tabledata(obj) {
      this.listLoading = true;
      recodelist(obj).then((response) => {
        this.packdate(response.data.data);
        this.tableData = response.data.data;
        this.currentPage = response.data.page_index;
        this.total_count = response.data.total_count;
        this.listLoading = false;
      });
    },
    packdate(obj) {
      // 拼装数据
      for (let i = 0; i < obj.length; i++) {
        //   obj[i].collection_time = this.$parseTime(Number(obj[i].collection_time));
        obj[i].create_date = obj[i].create_date.replace(/T/, " ");
        //   obj[i].period_date = (obj[i].period_date.replace(/T/, " ")).substring(0,obj[i].period_date.replace(/T/, " ").length-8);
        switch (obj[i].package_level_old) {
          case 1:
            obj[i].package_level_old = "一级包装";
            break;
          case 2:
            obj[i].package_level_old = "二级包装";
            break;
          case 3:
            obj[i].package_level_old = "三级包装";
            break;
          default:
            break;
        }
      }
    },
    //搜索事件
    search() {
      this.Tabledata({
        qrcode: this.searchform.qrcode,
        create_start_time:
          this.searchform.datelist == null ? null : this.searchform.datelist[0],
        create_end_time:
          this.searchform.datelist == null ? null : this.searchform.datelist[1],
        pageSize: this.searchform.pageSize,
      });
    },
    //重置按钮
    resetForm(formName) {
      this.$refs[formName].resetFields();
      this.Tabledata({
        qrcode: this.searchform.qrcode,
        create_start_time:
          this.searchform.datelist == null ? null : this.searchform.datelist[0],
        create_end_time:
          this.searchform.datelist == null ? null : this.searchform.datelist[1],
        pageSize: this.searchform.pageSize,
      });
    },
    //分页跳转事件
    currentchange(pageIndex) {
      this.searchform.pageIndex = pageIndex;
      this.Tabledata({
        qrcode: this.searchform.qrcode,
        create_start_time:
          this.searchform.datelist == null ? null : this.searchform.datelist[0],
        create_end_time:
          this.searchform.datelist == null ? null : this.searchform.datelist[1],
        pageIndex: this.searchform.pageIndex,
        pageSize: this.searchform.pageSize,
      });
    },
    //分页每页显示条数事件
    pagesize(pageSize) {
      this.searchform.pageSize = pageSize;
      this.search();
    },
    //导出表格事件
    handleDownload() {
      this.downloadLoading = true;
      const obj = {
        page_index: 1,
        pageSize: this.total_count,
        qrcode: this.searchform.qrcode,
        create_start_time:
          this.searchform.datelist == null ? null : this.searchform.datelist[0],
        create_end_time:
          this.searchform.datelist == null ? null : this.searchform.datelist[1],
      };
      recodelist(obj).then((response) => {
        this.packdate(response.data.data);
        this.tableDataDownload = response.data.data;

        console.log(this.tableDataDownload);
        import("@/vendor/Export2Excel").then((excel) => {
          const tHeader = [
            "编号",
            "盒码/箱码",
            "包装级别",
            "父级码",
            "父级包装级别",
            "订单",
            "生产批次",
            "保质期",
            "采集时间",
            "解除关联时间",
            "备注",
          ];
          const filterVal = [
            "id",
            "qrcode_old",
            "qrcode_level",
            "qrcode_parent",
            "package_level_parent",
            "orderno",
            "batchno",
            "period_date",
            "collection_time",
            "create_date",
            "create_user",
          ];
          const list = this.tableDataDownload;
          const data = this.formatJson(filterVal, list);
          excel.export_json_to_excel({
            header: tHeader,
            data,
            filename: this.filename,
            autoWidth: this.autoWidth,
            bookType: this.bookType,
          });
          this.downloadLoading = false;
        });
      }); // hear
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map((v) =>
        filterVal.map((j) => {
          if (j === "timestamp") {
            return parseTime(v[j]);
          } else {
            return v[j];
          }
        })
      );
    },
    //跳转页面
    tiaozhuan() {
      this.$router.push({
        path: "/staffedit",
      });
    },
  },
};
</script>
<style scoped></style>
